import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { toast } from "sonner";
import { pushQuickBooksMaster } from "../../utils/quickBooksTenant";

const QuickBooksPushPrompt = ({ open, pushPath, onDone }) => {
  const [pushing, setPushing] = useState(false);

  const handleLater = () => {
    if (pushing) return;
    onDone?.();
  };

  const handlePush = async () => {
    if (pushing) return;
    setPushing(true);
    try {
      const data = await pushQuickBooksMaster(pushPath);
      toast.success(data?.message || data?.msg || "Pushed to QuickBooks");
      onDone?.();
    } catch (error) {
      toast.error(error?.message || "Failed to push to QuickBooks");
    } finally {
      setPushing(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleLater} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontSize: "1rem", fontWeight: 600, pb: 1 }}>
        Push to QuickBooks
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: "0.875rem", color: "#212b36" }}>
          Saved in Ebusso. Please push these changes to QuickBooks.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 2, pb: 2 }}>
        <Button onClick={handleLater} disabled={pushing} sx={{ textTransform: "none" }}>
          Later
        </Button>
        <Button
          variant="contained"
          onClick={handlePush}
          disabled={pushing}
          sx={{ textTransform: "none" }}
        >
          {pushing ? "Pushing..." : "Push to QuickBooks"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QuickBooksPushPrompt;
